import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3","key":"svg-0"}]]

/**
 * IconBrandFacebook
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZmFjZWJvb2siCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgMTB2NGgzdjdoNHYtN2gzbDEgLTRoLTR2LTJhMSAxIDAgMCAxIDEgLTFoM3YtNGgtM2E1IDUgMCAwIDAgLTUgNXYyaC0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-facebook
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandFacebook = createReactComponent('outline', 'brand-facebook', 'BrandFacebook', __iconNode);

export default IconBrandFacebook;